import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const royaleldConfig: TSPConfig = {
  key: 'royaleld',
  name: 'RoyalELD',
  imageName: 'RoyalELD',
  category: TSPCategory.CUSTOM,
  helpText:
    "Please input the company ID from your RoyalELD profile. It should start with 'Company:' (like 'Company:12345').",
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID (e.g. Company:12345)',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default royaleldConfig;
